(() => {
  const MOBILE_BREAKPOINT = 750;
  const MIN_THUMB_PERCENT = 15;

  class FiltersScrollIndicator {
    constructor(filters) {
      this.filters = filters;
      this.indicator = document.createElement('div');
      this.indicator.className = 'general-filters-scroll';
      this.thumb = document.createElement('span');
      this.thumb.className = 'general-filters-scroll__thumb';
      this.indicator.appendChild(this.thumb);
      filters.insertAdjacentElement('afterend', this.indicator);

      this.update = this.update.bind(this);
      filters.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      if (window.ResizeObserver) {
        new ResizeObserver(this.update).observe(filters);
      }
      this.update();
    }

    update() {
      const { scrollWidth, clientWidth, scrollLeft } = this.filters;
      const scrollableWidth = scrollWidth - clientWidth;
      const isScrollable = scrollableWidth > 1 && window.innerWidth <= MOBILE_BREAKPOINT;

      this.indicator.classList.toggle('is-visible', isScrollable);
      if (!isScrollable) return;

      const thumbPercent = Math.max((clientWidth / scrollWidth) * 100, MIN_THUMB_PERCENT);
      const progress = scrollLeft / scrollableWidth;
      this.thumb.style.width = `${thumbPercent}%`;
      this.thumb.style.left = `${progress * (100 - thumbPercent)}%`;
    }
  }

  const init = () => {
    document.querySelectorAll('.general-filters').forEach((filters) => {
      if (filters.dataset.scrollIndicator) return;
      filters.dataset.scrollIndicator = 'true';
      new FiltersScrollIndicator(filters);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
